const EVENT_NAMES = Object.freeze({
  TAB_UPDATED: 'section-tabs:updated',
});

const Events = {
  TabUpdated(tabEl) {
    const event = new CustomEvent(EVENT_NAMES.TAB_UPDATED, {
      detail: tabEl,
    });

    return event;
  },
};

export { EVENT_NAMES, Events };
